<template>
  <div>
    <el-row>
      <el-col :md="12" :sm="24">
        <el-input size="small" placeholder="请输入关键字搜索" v-model="searchName" class="input-with-select">
          <el-button type="primary" slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
      <el-col :md="12" :sm="24">
          <el-button type="primary" style="float: right" icon="el-icon-plus" size="small" @click="add">新建客户</el-button>
      </el-col>
    </el-row>
    <div style="height: 20px"></div>
    <datatable
      :height="350"
      :highlight="true"
      :loading="loading"
      :tableQuery="tableQuery"
      :tableData="tableData"
      @table-current-change="handleCurrentChange"
      @current-change="tableQuery.page=$event, search()"
      @size-change="tableQuery.size=$event, search()">
      <el-table-column label="选择" width="60">
        <template slot-scope="scope">
          <a-checkbox @change="handleCurrentChange(scope.row)" :checked="scope.row.checkd"></a-checkbox>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="客户名称" prop="customerName"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="城市">
        <template slot-scope="scope">
          {{scope.row.city}}
        </template>
      </el-table-column>
    </datatable>
    <div style="text-align: right;margin-top: 20px">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button type="primary" size="small" @click="ok">确定</el-button>
    </div>
    <el-dialog
      title="新建客户"
      append-to-body
      :visible.sync="addModel"
      width="950px">
      <insertCustomer @cancelInsertCustomer="addModel = false" @addComplete="addComplete"></insertCustomer>
    </el-dialog>
  </div>
</template>
<script>
import { listCustomer } from '@/api/resource'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  props: {
    fanwei: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      addModel: false,
      searchName: '',
      loading: true,
      tableData: {
        aaData: []
      },
      tableQuery: {
        page: 0,
        size: 5,
        filter: '',
        order: 't1.work_id=desc'
      },
      val: {
        id: '0'
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    addComplete () {
      this.addModel = false
      this.search()
    },
    search () {
      this.loading = true
      // fanwei 1我自己的 2公司所有的
      if (this.fanwei === 1) {
        this.tableQuery.filter = 'creatorId=' + this.userInfo.id + ';customerName=' + this.searchName
      } else if (this.fanwei === 2) {
        this.tableQuery.filter =
          'creatorId=' + this.userInfo.id +
          ';all=1;customerName=' + this.searchName
      }
      listCustomer(this.tableQuery).then((res) => {
        this.tableData = res.data.data
        this.tableData.aaData.forEach(m => {
          m.checkd = false
        })
        this.loading = false
      }).catch(reason => {
        this.loading = false
      })
    },
    handleChange (val) {
      this.val = val
    },
    handleCurrentChange (val) {
      if (val !== null && val !== '') {
        this.tableData.aaData.forEach(m => {
          if (m.id === val.id) {
            m.checkd = true
            this.handleChange(m)
          } else {
            m.checkd = false
          }
        })
      }
    },
    cancel () {
      this.$emit('chooseCancel')
    },
    ok () {
      if (this.val.id === '0') {
        this.$notify({
          title: '警告',
          message: '必须选择',
          type: 'warning'
        })
      } else {
        this.$emit('chooseOk', this.val)
      }
    },
    add () {
      this.addModel = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/choose_customer/index.vue